import * as React from 'react'
import Datetime from 'react-datetime'
import moment, { Moment } from 'moment-timezone'

interface IDatePickerProps {
  value?: string | Moment | Date | undefined
  onDateChange?: (date: Moment | string) => void
  onChange: (date: Moment | string) => void
}

const DatePicker: React.FC<IDatePickerProps> = props => {
  return (
    <Datetime
      dateFormat="MM/DD/YYYY"
      timeFormat={false}
      onChange={selectedDate => {
        if (props.onDateChange) {
          props.onDateChange(selectedDate)
        }
        if (props.onChange) {
          props.onChange(selectedDate)
        }
      }}
      value={props.value}
      isValidDate={(currentDate) =>  (currentDate.isBefore(moment()))}
      inputProps={{ placeholder: 'MM/DD/YYYY' }}
    />
  )
}
export default DatePicker
